import { ORDER_METHODS } from '../../../../../../../services/exports/Constants';

export default {
  order_method_details: {
    title: '{{orderMethod}} en {{waitingTime}} min',
  },
  order_methods: {
    [ORDER_METHODS.DELIVERY]: 'Entrega',
    [ORDER_METHODS.PICKUP]: 'Recogida',
    [ORDER_METHODS.ON_SITE]: 'Pedido en mesa',
  },
};
